import { catchError, Observable, OperatorFunction, throwError } from 'rxjs';

/**
 * Catch an error and log for track js to consume
 * By default the error is re-thrown
 */
export function catchAndLogError<T, R = T>(caught?: Observable<R>): OperatorFunction<T, T | R> {
  return catchError((error) => {
    console.error(error);
    return caught ?? throwError(() => error);
  });
}
